import React from 'react'
import { Loader } from 'semantic-ui-react'
import Delayed from "../delayed";

export default class ComponentLoader extends React.PureComponent {
  render() {
    return <Delayed><Loader active inline size='small'/></Delayed>
  }
}
